import { NotificationActionEnum } from "./INotification";

export type FilterOperationType = 'equal' |
  'between' |
  'before' |
  'after' |
  'onOrBefore' |
  'onOrAfter';

export interface IUserDescription {
  name: string,
  img?: string,
}

export interface IFiltroOptions {
  id: string;
  key: NotificationFilterTypeKeys;
  values: any;
  operation: FilterOperationType;
  description?: string | string[] | IUserDescription[];
}

export type FiltersRecordType = Record<string, IFiltroOptions>;

export type OPType = 'id' | 'op' | 'vl';

export type NotificationFilterTypeKeys = 'authorIds' |
  'actions' |
  'csIds' |
  'creationDate' |
  'isRead';

export interface IValuesFilter {
  id?: string;
  key?: NotificationFilterTypeKeys;
  operation?: FilterOperationType;
  values?: any;
  description?: string[];
  override?: boolean;
}

export interface IUpdateFilter {
  op: OPType;
  values: IValuesFilter;
}

export const arrayNotificationKeys = [
  'authorIds',
  'actions',
  'csIds',
  'creationDate',
  'isRead',
];

export const arrayActionKeys = [
  NotificationActionEnum.FileCreated,
  NotificationActionEnum.FileDeleted,
  NotificationActionEnum.FileMoved,
  NotificationActionEnum.FileVersionAdded,
  NotificationActionEnum.FileStatusChanged,
  NotificationActionEnum.FileRenamed,
  NotificationActionEnum.FileDescriptionUpdated,
  NotificationActionEnum.FileCreatedObsolet,
  NotificationActionEnum.FolderCreated,
  NotificationActionEnum.FolderRenamed,
  NotificationActionEnum.FolderDeleted,

  NotificationActionEnum.TopicCreated,
  NotificationActionEnum.TopicUpdated,
  NotificationActionEnum.TopicStatusChanged,
  NotificationActionEnum.TopicDeleted,
  NotificationActionEnum.TopicAttachmentAdded,
  NotificationActionEnum.TopicAttachmentDeleted,
  NotificationActionEnum.TopicCommentAdded,
  NotificationActionEnum.TopicExpiresTommorow,
  NotificationActionEnum.TopicExpiresToday,
  NotificationActionEnum.TopicExpiredYesterday,

  NotificationActionEnum.PlottingCreated,
  NotificationActionEnum.PlottingStatusChanged,
  NotificationActionEnum.PlottingFileDeleted,
  NotificationActionEnum.PlottingRequestDeleted,

  NotificationActionEnum.DisciplineCreated,
  NotificationActionEnum.DisciplineDeleted,
  NotificationActionEnum.DisciplineRenamed,
  NotificationActionEnum.DisciplineDisconnected,
  NotificationActionEnum.DisciplineReconnected,
];

export const arrayNotificationKeysPtBr: Record<NotificationActionEnum, string> = {
  [NotificationActionEnum.FileCreated]: 'Novo arquivo',
  [NotificationActionEnum.FileDeleted]: 'Arquivo excluído',
  [NotificationActionEnum.FileMoved]: 'Arquivo movido',
  [NotificationActionEnum.FileVersionAdded]: 'Nova revisão de arquivo',
  [NotificationActionEnum.FileStatusChanged]: 'Status do arquivo alterado',
  [NotificationActionEnum.FileRenamed]: 'Arquivo renomeado',
  [NotificationActionEnum.FileDescriptionUpdated]: 'Descrição do arquivo alterada',
  [NotificationActionEnum.FileCreatedObsolet]: 'Arquivo movido para obsoleto',
  [NotificationActionEnum.FileRendered]: 'Arquivo renderizado',
  [NotificationActionEnum.FolderCreated]: 'Nova pasta',
  [NotificationActionEnum.FolderRenamed]: 'Pasta renomeada',
  [NotificationActionEnum.FolderDeleted]: 'Pasta excluída',

  [NotificationActionEnum.TopicCreated]: 'Nova atividade',
  [NotificationActionEnum.TopicUpdated]: 'Atividade atualizada',
  [NotificationActionEnum.TopicStatusChanged]: 'Status da atividade alterado',
  [NotificationActionEnum.TopicDeleted]: 'Atividade excluída',
  [NotificationActionEnum.TopicAttachmentAdded]: 'Novo anexo na atividade',
  [NotificationActionEnum.TopicAttachmentDeleted]: 'Anexo da atividade excluído',
  [NotificationActionEnum.TopicCommentAdded]: 'Novo comentário na atividade',
  [NotificationActionEnum.TopicExpiresTommorow]: 'Prazo marcado para amanhã',
  [NotificationActionEnum.TopicExpiresToday]: 'Prazo marcado para hoje',
  [NotificationActionEnum.TopicExpiredYesterday]: 'Prazo venceu ontem',

  [NotificationActionEnum.PlottingCreated]: 'Nova solicitação de plotagem',
  [NotificationActionEnum.PlottingStatusChanged]: 'Status da plotagem alterado',
  [NotificationActionEnum.PlottingFileDeleted]: 'Solicitação de plotagem excluída',
  [NotificationActionEnum.PlottingRequestDeleted]: 'Plotagem excluída da solicitação',
  [NotificationActionEnum.PlottingCreatedObsolet]: 'Plotagem movida para obsoleto',

  [NotificationActionEnum.DisciplineCreated]: 'Nova disciplina',
  [NotificationActionEnum.DisciplineDeleted]: 'Disciplina excluída',
  [NotificationActionEnum.DisciplineRenamed]: 'Disciplina renomeada',
  [NotificationActionEnum.DisciplineDisconnected]: 'Disciplina desconectada',
  [NotificationActionEnum.DisciplineReconnected]: 'Disciplina reconectada',

  [NotificationActionEnum.BcfImportCompleted]: 'Importação BCF concluída',
  [NotificationActionEnum.BcfExportCompleted]: 'Exportação BCF concluída',
};
